



























import DealerInfo from './DealerInfo.vue';
import Dealer from '@/models/dealer.model';
import Marker from '@/models/marker.model';
import State from '@/classes/state';
import { DealerDetails } from '@/models/dealer-details.model';

export default {
    name: 'DealerList',
    components: {
        DealerInfo,
    },
    props: {
        markers: {
            type: Array,
            required: true,
        },
        dealerListId: {
            type: String,
            required: true,
        },
    },
    data() {
        const { translations } = this.$store.state;

        return {
            scrollElement: null,
            detailsMarker: null,
            dealerDetails: null,
            detailsOpen: false,
            translations,
        };
    },
    computed: {
        activeDealerDetails(): DealerDetails | null {
            return (this.$store.state as State).activeDealerDetails;
        },
        dealerListOpen(): boolean {
            return (this.$store.state as State).dealerListOpen;
        },
    },
    watch: {
        markers(): void {
            this.scrollToTop();
        },
        activeDealerDetails(
            newActiveDealerDetails: DealerDetails | null,
            prevActiveDealerDetails: DealerDetails | null
        ): void {
            this.dealerDetails = newActiveDealerDetails ? newActiveDealerDetails : prevActiveDealerDetails;
            this.detailsOpen = !!newActiveDealerDetails;
        },
    },
    methods: {
        scrollToTop() {
            if (!this.scrollElement) {
                return;
            }

            this.scrollElement.scrollTop = 0;
        },
        openDetails(dealerDetails: DealerDetails) {
            this.$store.dispatch('setActiveMarkerId', dealerDetails.dealer.id);
            this.$store.dispatch('setActiveDealerDetails', dealerDetails);
        },
        closeDetails() {
            this.$store.dispatch('setActiveMarkerId', null);
            this.$store.dispatch('setActiveDealerDetails', null);
        },
        handleMouseEnter(marker: Marker<Dealer>) {
            this.highlightMarker(marker, true);
        },
        handleMouseLeave(marker: Marker<Dealer>) {
            const activeDealerDetails: DealerDetails | null = this.activeDealerDetails;

            if (activeDealerDetails && marker.data && activeDealerDetails.dealer.id === marker.data.id) {
                // user clicked the marker so it should stay highlighted
                return;
            }

            this.highlightMarker(marker, false);
        },
        highlightMarker(marker: Marker<Dealer>, highlight: boolean) {
            const markerData = marker.data;

            if (!markerData) {
                return;
            }

            const dealerId = markerData.id;
            this.$store.dispatch('setActiveMarkerId', highlight ? dealerId : null);
        },
    },
    mounted() {
        this.scrollElement = this.$el.querySelector('.mdl-dealer-search-list__list');
    },
}
